import Calender from "assets/svg/package-details/calender.svg";
import Clock from "assets/svg/package-details/clock.svg";
import Degree from "assets/svg/package-details/degree.svg";
import Write from "assets/svg/package-details/write.svg";
import React, { FC, useEffect } from "react";
import { convertMiladiToJalali } from "src/utils";

type Props = {
  numerofSessions: string;
  duration: string;
  releaseDate: string;
  startDate: string;
  endDate: string;
  hasCertificate: boolean;
};
const Cards: FC<Props> = ({
  duration,
  numerofSessions,
  releaseDate,
  hasCertificate,
  startDate,
  endDate,
}) => {
  const data = [
    {
      title: `تعداد کلی جلسات ${numerofSessions ?? 0}`,
      color: "#0577AF",
      bgIcon: "rgba(5, 119, 175, 0.2)",
      background:
        "linear-gradient(270deg, rgba(54, 100, 148, 0.2) 0%, rgba(4, 128, 212, 0.2) 50%, rgba(39, 178, 188, 0.2) 100%)",
      Icon: Write,
    },
    {
      title: `مدت دوره ${duration ? duration : ""}`,
      bgIcon: "rgba(79, 155, 11, 0.2)",
      color: "#4F9B0B",
      background:
        "linear-gradient(267.36deg, rgba(66, 135, 4, 0.2) 3.01%, rgba(79, 155, 10, 0.2) 36.17%, rgba(120, 177, 66, 0.2) 65.82%, rgba(161, 206, 119, 0.2) 98.99%)",
      Icon: Clock,
    },
    {
      title: `${
        releaseDate
          ? `تاریخ انتشار ${convertMiladiToJalali(releaseDate)}`
          : `تاریخ بسته ${
              startDate ? convertMiladiToJalali(startDate) : ""
            } الی ${endDate ? convertMiladiToJalali(endDate) : ""}`
      }`,
      color: "#EE8A1E",
      bgIcon: "rgba(238, 138, 30, 0.2)",
      background:
        "linear-gradient(267.5deg, rgba(230, 88, 0, 0.2) 4.11%, rgba(227, 128, 30, 0.2) 50.88%, rgba(254, 189, 23, 0.2) 97.65%)",
      Icon: Calender,
    },
    {
      title: "با ارائه مدرک پایان دوره",
      color: "#77268B",
      bgIcon: "rgba(119, 38, 139, 0.2)",
      background:
        "linear-gradient(267.42deg, rgba(60, 20, 154, 0.1) 4.67%, rgba(152, 19, 179, 0.1) 53.73%, rgba(208, 63, 178, 0.1) 96.48%)",
      Icon: Degree,
    },
  ];

  hasCertificate == false && data.splice(-1);

  return (
    <div
      className={
        "mt-4 grid grid-cols-1 gap-x-2  gap-y-3 px-[10%] md:mt-10 md:grid-cols-2 md:gap-y-[30px] lg:mt-16 lg:gap-y-0 lg:px-[13%] " +
        `${hasCertificate ? "xl:grid-cols-4" : "xl:grid-cols-3"}`
      }
    >
      {data.map(({ Icon, background, color, title, bgIcon }) => (
        <div key={color} className="w-full">
          <div className="mb-2 flex w-full items-center gap-x-1">
            <div
              className={`h-[5px] w-full rounded-lg`}
              style={{ background: color }}
            ></div>
            <div
              className={`bg-[${color}] rounded-full`}
              style={{ minWidth: 10, minHeight: 10, background: color }}
            ></div>
            <div
              style={{ background: color }}
              className={`h-[5px] w-full rounded-lg`}
            ></div>
          </div>
          <div
            style={{
              background: background,
            }}
            className="flex h-[90px] w-full items-center gap-x-5 rounded px-5"
          >
            <div
              className={`flex h-[35px] w-[35px] items-center justify-center rounded p-1`}
              style={{ background: bgIcon }}
            >
              <Icon className="h-[25px] w-[25px]" />
            </div>
            <span className="scrollbar-none overflow-x-auto whitespace-pre-line text-sm md:text-lg xl:text-base 3xl:text-xl">
              {title}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Cards;
